<template>
  <div class="wrapper">
    <div class="container">
      <md-card class="customCard navbar-margin">
        <md-card-content>
          <div class="tim-typo">
            <h2 class="title">Carports</h2> 
            <p>Konstruktion aus Aluminium farbpulverbeschichtet, statisch geprüft, Eindeckung Stegdoppelplatten oder VSG-Verbundsicherheitsglas.</p>
          </div>
          <div class="gallery">
            <div class="gallery-panel"
              v-for="image in images"
              :key="image.id">
              <mdb-view  class="rounded z-depth-1-half" :src=image.pathLong alt="">
                <mdb-mask flex-center >
                  <p class="panel-titel"> {{image.fileName[0]}} </p>
                </mdb-mask>
              </mdb-view>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>


import { mdbView, mdbMask } from "mdbvue";

export default {
  name: 'Gallery',
  data() {
    return {
      images: [],
    };
  },
  mounted() {
    //declare the folder path to the product image folder here
    this.importAll(require.context('../assets/prod_images/Carport/', true, /\.jpg$/));
  },
  methods: {
    importAll(r) {
      r.keys().forEach(key => (this.images.push({ pathLong: r(key), pathShort: key, fileName: key.match(/[ \w-]+?(?=\.)/) })));
    },
    onResponsiveInverted() {
      if (window.innerWidth < 600) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  },
  components: {
    mdbView,
    mdbMask
  }
};
</script>